// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"462":"2be37e24","679":"7c41506f","693":"d4e88743","983":"063d61f3"}[chunkId] + ".chunk.js";
};